/* tslint:disable */
/* eslint-disable */
/**
 * chomestatus API
 * The API for chromestatus.com. chromestatus.com is the official tool used for tracking feature launches in Blink (the browser engine that powers Chrome and many other web browsers). This tool guides feature owners through our launch process and serves as a primary source for developer information that then ripples throughout the web developer ecosystem. More details at: https://github.com/GoogleChrome/chromium-dashboard
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AccountResponseFromJSON, ActivityFromJSON, AddAttachmentResponseFromJSON, CommentsRequestToJSON, ComponentUsersRequestToJSON, ComponentsUsersResponseFromJSON, CreateAccountRequestToJSON, CreateOriginTrialRequestToJSON, DeleteAccount200ResponseFromJSON, DismissCueRequestToJSON, ExternalReviewsResponseFromJSON, FeatureLatencyFromJSON, FeatureLinksResponseFromJSON, FeatureLinksSampleFromJSON, FeatureLinksSummaryResponseFromJSON, GetCommentsResponseFromJSON, GetGateResponseFromJSON, GetIntentResponseFromJSON, GetOriginTrialsResponseFromJSON, GetSettingsResponseFromJSON, GetStarsResponseFromJSON, GetVotesResponseFromJSON, MessageResponseFromJSON, PatchCommentRequestToJSON, PatchGateRequestToJSON, PermissionsResponseFromJSON, PostIntentRequestToJSON, PostSettingsRequestToJSON, PostVoteRequestToJSON, ProcessFromJSON, ReviewLatencyFromJSON, SetStarRequestToJSON, SignInRequestToJSON, SpecMentorFromJSON, SuccessMessageFromJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Store a file that will be attached to a feature
     */
    addAttachmentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling addAttachment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['uploadedFile'] != null) {
                formParams.append('uploaded-file', requestParameters['uploadedFile']);
            }
            const response = yield this.request({
                path: `/features/{feature_id}/attachments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AddAttachmentResponseFromJSON(jsonValue));
        });
    }
    /**
     * Store a file that will be attached to a feature
     */
    addAttachment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addAttachmentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Add a comment to a feature
     */
    addFeatureCommentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling addFeatureComment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/<int:feature_id>/approvals/comments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CommentsRequestToJSON(requestParameters['commentsRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Add a comment to a feature
     */
    addFeatureComment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addFeatureCommentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Add a comment to a specific gate
     */
    addGateCommentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling addGateComment().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling addGateComment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/<int:feature_id>/approvals/<int:gate_id>/comments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CommentsRequestToJSON(requestParameters['commentsRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Add a comment to a specific gate
     */
    addGateComment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addGateCommentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Add a user to a component
     */
    addUserToComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['componentId'] == null) {
                throw new runtime.RequiredError('componentId', 'Required parameter "componentId" was null or undefined when calling addUserToComponent().');
            }
            if (requestParameters['userId'] == null) {
                throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling addUserToComponent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-Xsrf-Token"] = yield this.configuration.apiKey("X-Xsrf-Token"); // XsrfToken authentication
            }
            const response = yield this.request({
                path: `/components/{componentId}/users/{userId}`.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters['componentId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ComponentUsersRequestToJSON(requestParameters['componentUsersRequest']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Add a user to a component
     */
    addUserToComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addUserToComponentRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Add a full set of cross-functional gates to a stage.
     */
    addXfnGatesToStageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling addXfnGatesToStage().');
            }
            if (requestParameters['stageId'] == null) {
                throw new runtime.RequiredError('stageId', 'Required parameter "stageId" was null or undefined when calling addXfnGatesToStage().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/stages/{stage_id}/addXfnGates`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"stage_id"}}`, encodeURIComponent(String(requestParameters['stageId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Add a full set of cross-functional gates to a stage.
     */
    addXfnGatesToStage(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addXfnGatesToStageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Authenticate user with Google Sign-In
     */
    authenticateUserRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['signInRequest'] == null) {
                throw new runtime.RequiredError('signInRequest', 'Required parameter "signInRequest" was null or undefined when calling authenticateUser().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/login`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SignInRequestToJSON(requestParameters['signInRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Authenticate user with Google Sign-In
     */
    authenticateUser(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticateUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new account
     */
    createAccountRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/accounts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateAccountRequestToJSON(requestParameters['createAccountRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AccountResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create a new account
     */
    createAccount() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.createAccountRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new origin trial
     */
    createOriginTrialRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling createOriginTrial().');
            }
            if (requestParameters['stageId'] == null) {
                throw new runtime.RequiredError('stageId', 'Required parameter "stageId" was null or undefined when calling createOriginTrial().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/origintrials/{feature_id}/{stage_id}/create`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"stage_id"}}`, encodeURIComponent(String(requestParameters['stageId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateOriginTrialRequestToJSON(requestParameters['createOriginTrialRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Create a new origin trial
     */
    createOriginTrial(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createOriginTrialRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete an account
     */
    deleteAccountRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['accountId'] == null) {
                throw new runtime.RequiredError('accountId', 'Required parameter "accountId" was null or undefined when calling deleteAccount().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/accounts/{account_id}`.replace(`{${"account_id"}}`, encodeURIComponent(String(requestParameters['accountId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteAccount200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * Delete an account
     */
    deleteAccount(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteAccountRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Dismiss a cue card for the signed-in user
     */
    dismissCueRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['dismissCueRequest'] == null) {
                throw new runtime.RequiredError('dismissCueRequest', 'Required parameter "dismissCueRequest" was null or undefined when calling dismissCue().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/currentuser/cues`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DismissCueRequestToJSON(requestParameters['dismissCueRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Dismiss a cue card for the signed-in user
     */
    dismissCue(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dismissCueRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Extend an existing origin trial
     */
    extendOriginTrialRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling extendOriginTrial().');
            }
            if (requestParameters['extensionStageId'] == null) {
                throw new runtime.RequiredError('extensionStageId', 'Required parameter "extensionStageId" was null or undefined when calling extendOriginTrial().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/origintrials/{feature_id}/{extension_stage_id}/extend`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"extension_stage_id"}}`, encodeURIComponent(String(requestParameters['extensionStageId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Extend an existing origin trial
     */
    extendOriginTrial(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extendOriginTrialRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get dismissed cues for the current user
     */
    getDismissedCuesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/currentuser/cues`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get dismissed cues for the current user
     */
    getDismissedCues(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDismissedCuesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all comments for a given feature
     */
    getFeatureCommentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getFeatureComments().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/<int:feature_id>/approvals/comments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCommentsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get all comments for a given feature
     */
    getFeatureComments(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFeatureCommentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get feature links by feature_id
     */
    getFeatureLinksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['featureId'] != null) {
                queryParameters['feature_id'] = requestParameters['featureId'];
            }
            if (requestParameters['updateStaleLinks'] != null) {
                queryParameters['update_stale_links'] = requestParameters['updateStaleLinks'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/feature_links`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FeatureLinksResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get feature links by feature_id
     */
    getFeatureLinks() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getFeatureLinksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get feature links samples
     */
    getFeatureLinksSamplesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['domain'] != null) {
                queryParameters['domain'] = requestParameters['domain'];
            }
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            if (requestParameters['isError'] != null) {
                queryParameters['is_error'] = requestParameters['isError'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/feature_links_samples`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FeatureLinksSampleFromJSON(jsonValue));
        });
    }
    /**
     * Get feature links samples
     */
    getFeatureLinksSamples() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getFeatureLinksSamplesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get feature links summary
     */
    getFeatureLinksSummaryRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/feature_links_summary`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FeatureLinksSummaryResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get feature links summary
     */
    getFeatureLinksSummary(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFeatureLinksSummaryRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all comments for a given gate
     */
    getGateCommentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getGateComments().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling getGateComments().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/<int:feature_id>/approvals/<int:gate_id>/comments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActivityFromJSON));
        });
    }
    /**
     * Get all comments for a given gate
     */
    getGateComments(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGateCommentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all gates for a feature
     */
    getGatesForFeatureRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getGatesForFeature().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/gates`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetGateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get all gates for a feature
     */
    getGatesForFeature(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGatesForFeatureRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the HTML body of an intent draft
     */
    getIntentBodyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getIntentBody().');
            }
            if (requestParameters['stageId'] == null) {
                throw new runtime.RequiredError('stageId', 'Required parameter "stageId" was null or undefined when calling getIntentBody().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling getIntentBody().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/{stage_id}/{gate_id}/intent`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"stage_id"}}`, encodeURIComponent(String(requestParameters['stageId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetIntentResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get the HTML body of an intent draft
     */
    getIntentBody(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIntentBodyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get origin trials
     */
    getOriginTrialsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/origintrials`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetOriginTrialsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get origin trials
     */
    getOriginTrials(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOriginTrialsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all pending gates
     */
    getPendingGatesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/gates/pending`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetGateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get all pending gates
     */
    getPendingGates(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPendingGatesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the process for a feature
     */
    getProcessRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getProcess().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/process`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProcessFromJSON(jsonValue));
        });
    }
    /**
     * Get the process for a feature
     */
    getProcess(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProcessRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the progress for a feature
     */
    getProgressRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getProgress().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/progress`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get the progress for a feature
     */
    getProgress(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProgressRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a list of all starred feature IDs for the signed-in user
     */
    getStarsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/currentuser/stars`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStarsResponseFromJSON));
        });
    }
    /**
     * Get a list of all starred feature IDs for the signed-in user
     */
    getStars(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStarsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the permissions and email of the user
     */
    getUserPermissionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['returnPairedUser'] != null) {
                queryParameters['returnPairedUser'] = requestParameters['returnPairedUser'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/currentuser/permissions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PermissionsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get the permissions and email of the user
     */
    getUserPermissions() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.getUserPermissionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get user settings
     */
    getUserSettingsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/currentuser/settings`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSettingsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get user settings
     */
    getUserSettings(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserSettingsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get votes for a feature
     */
    getVotesForFeatureRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getVotesForFeature().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/votes`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetVotesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get votes for a feature
     */
    getVotesForFeature(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getVotesForFeatureRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get votes for a feature and gate
     */
    getVotesForFeatureAndGateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling getVotesForFeatureAndGate().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling getVotesForFeatureAndGate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/features/{feature_id}/votes/{gate_id}`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetVotesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get votes for a feature and gate
     */
    getVotesForFeatureAndGate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getVotesForFeatureAndGateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get Baseline web feature IDs
     */
    getWebFeatureIdsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/web_feature_ids`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get Baseline web feature IDs
     */
    getWebFeatureIds(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWebFeatureIdsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List all components and possible users
     */
    listComponentUsersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-Xsrf-Token"] = yield this.configuration.apiKey("X-Xsrf-Token"); // XsrfToken authentication
            }
            const response = yield this.request({
                path: `/componentsusers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ComponentsUsersResponseFromJSON(jsonValue));
        });
    }
    /**
     * List all components and possible users
     */
    listComponentUsers(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listComponentUsersRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List features whose external reviews are incomplete
     */
    listExternalReviewsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['reviewGroup'] == null) {
                throw new runtime.RequiredError('reviewGroup', 'Required parameter "reviewGroup" was null or undefined when calling listExternalReviews().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/external_reviews/{review_group}`.replace(`{${"review_group"}}`, encodeURIComponent(String(requestParameters['reviewGroup']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ExternalReviewsResponseFromJSON(jsonValue));
        });
    }
    /**
     * List features whose external reviews are incomplete
     */
    listExternalReviews(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listExternalReviewsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List how long each feature took to launch
     */
    listFeatureLatencyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['startAt'] == null) {
                throw new runtime.RequiredError('startAt', 'Required parameter "startAt" was null or undefined when calling listFeatureLatency().');
            }
            if (requestParameters['endAt'] == null) {
                throw new runtime.RequiredError('endAt', 'Required parameter "endAt" was null or undefined when calling listFeatureLatency().');
            }
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'].toISOString().substring(0, 10);
            }
            if (requestParameters['endAt'] != null) {
                queryParameters['endAt'] = requestParameters['endAt'].toISOString().substring(0, 10);
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/feature-latency`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureLatencyFromJSON));
        });
    }
    /**
     * List how long each feature took to launch
     */
    listFeatureLatency(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listFeatureLatencyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List recently reviewed features and their review latency
     */
    listReviewsWithLatencyRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/review-latency`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReviewLatencyFromJSON));
        });
    }
    /**
     * List recently reviewed features and their review latency
     */
    listReviewsWithLatency(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listReviewsWithLatencyRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List spec mentors and their activity
     */
    listSpecMentorsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['after'] != null) {
                queryParameters['after'] = requestParameters['after'].toISOString().substring(0, 10);
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/spec_mentors`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpecMentorFromJSON));
        });
    }
    /**
     * List spec mentors and their activity
     */
    listSpecMentors() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.listSpecMentorsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Log out the current user
     */
    logoutUserRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/logout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Log out the current user
     */
    logoutUser(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.logoutUserRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Submit an intent to be posted on blink-dev
     */
    postIntentToBlinkDevRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling postIntentToBlinkDev().');
            }
            if (requestParameters['stageId'] == null) {
                throw new runtime.RequiredError('stageId', 'Required parameter "stageId" was null or undefined when calling postIntentToBlinkDev().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling postIntentToBlinkDev().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/{feature_id}/{stage_id}/{gate_id}/intent`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"stage_id"}}`, encodeURIComponent(String(requestParameters['stageId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PostIntentRequestToJSON(requestParameters['postIntentRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseFromJSON(jsonValue));
        });
    }
    /**
     * Submit an intent to be posted on blink-dev
     */
    postIntentToBlinkDev(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postIntentToBlinkDevRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Refresh the XSRF token
     */
    refreshTokenRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/currentuser/token`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReviewLatencyFromJSON));
        });
    }
    /**
     * Refresh the XSRF token
     */
    refreshToken(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.refreshTokenRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * reject unneeded GET request without triggering Error Reporting
     */
    rejectGetRequestsLoginRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/login`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * reject unneeded GET request without triggering Error Reporting
     */
    rejectGetRequestsLogin(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.rejectGetRequestsLoginRaw(initOverrides);
        });
    }
    /**
     * reject unneeded GET request without triggering Error Reporting
     */
    rejectGetRequestsLogoutRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/logout`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * reject unneeded GET request without triggering Error Reporting
     */
    rejectGetRequestsLogout(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.rejectGetRequestsLogoutRaw(initOverrides);
        });
    }
    /**
     * Remove a user from a component
     */
    removeUserFromComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['componentId'] == null) {
                throw new runtime.RequiredError('componentId', 'Required parameter "componentId" was null or undefined when calling removeUserFromComponent().');
            }
            if (requestParameters['userId'] == null) {
                throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling removeUserFromComponent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-Xsrf-Token"] = yield this.configuration.apiKey("X-Xsrf-Token"); // XsrfToken authentication
            }
            const response = yield this.request({
                path: `/components/{componentId}/users/{userId}`.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters['componentId']))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: ComponentUsersRequestToJSON(requestParameters['componentUsersRequest']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove a user from a component
     */
    removeUserFromComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeUserFromComponentRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Set the assignees for a gate.
     */
    setAssigneesForGateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling setAssigneesForGate().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling setAssigneesForGate().');
            }
            if (requestParameters['patchGateRequest'] == null) {
                throw new runtime.RequiredError('patchGateRequest', 'Required parameter "patchGateRequest" was null or undefined when calling setAssigneesForGate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/{feature_id}/gates/{gate_id}`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: PatchGateRequestToJSON(requestParameters['patchGateRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Set the assignees for a gate.
     */
    setAssigneesForGate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setAssigneesForGateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Set or clear a star on the specified feature
     */
    setStarRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['setStarRequest'] == null) {
                throw new runtime.RequiredError('setStarRequest', 'Required parameter "setStarRequest" was null or undefined when calling setStar().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/currentuser/stars`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SetStarRequestToJSON(requestParameters['setStarRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Set or clear a star on the specified feature
     */
    setStar(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setStarRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Set the user settings (currently only the notify_as_starrer)
     */
    setUserSettingsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['postSettingsRequest'] == null) {
                throw new runtime.RequiredError('postSettingsRequest', 'Required parameter "postSettingsRequest" was null or undefined when calling setUserSettings().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/currentuser/settings`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PostSettingsRequestToJSON(requestParameters['postSettingsRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Set the user settings (currently only the notify_as_starrer)
     */
    setUserSettings(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setUserSettingsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Set a user\'s vote value for the specific feature and gate.
     */
    setVoteForFeatureAndGateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling setVoteForFeatureAndGate().');
            }
            if (requestParameters['gateId'] == null) {
                throw new runtime.RequiredError('gateId', 'Required parameter "gateId" was null or undefined when calling setVoteForFeatureAndGate().');
            }
            if (requestParameters['postVoteRequest'] == null) {
                throw new runtime.RequiredError('postVoteRequest', 'Required parameter "postVoteRequest" was null or undefined when calling setVoteForFeatureAndGate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/{feature_id}/votes/{gate_id}`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))).replace(`{${"gate_id"}}`, encodeURIComponent(String(requestParameters['gateId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PostVoteRequestToJSON(requestParameters['postVoteRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Set a user\'s vote value for the specific feature and gate.
     */
    setVoteForFeatureAndGate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.setVoteForFeatureAndGateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update a comment on a feature
     */
    updateFeatureCommentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureId'] == null) {
                throw new runtime.RequiredError('featureId', 'Required parameter "featureId" was null or undefined when calling updateFeatureComment().');
            }
            if (requestParameters['patchCommentRequest'] == null) {
                throw new runtime.RequiredError('patchCommentRequest', 'Required parameter "patchCommentRequest" was null or undefined when calling updateFeatureComment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/features/<int:feature_id>/approvals/comments`.replace(`{${"feature_id"}}`, encodeURIComponent(String(requestParameters['featureId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: PatchCommentRequestToJSON(requestParameters['patchCommentRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageFromJSON(jsonValue));
        });
    }
    /**
     * Update a comment on a feature
     */
    updateFeatureComment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateFeatureCommentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const ListExternalReviewsReviewGroupEnum = {
    tag: 'tag',
    gecko: 'gecko',
    webkit: 'webkit'
};
